import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Box,
    Dialog,
    DialogContent,
    makeStyles,
    Typography,
} from '@material-ui/core';
import * as actions from '../store/actions';
import { ITheme } from '../themes/custom/ITheme';
import SnackBarType from '../objects/app/snackbar';
import { IIndexable } from '../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import GarmentList from '../components/GarmentsList/GarmentList';
import Garment from '../objects/garments/garment';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';
import KapinuaDialogTitle from '../components/KapinuaDialog/KapinuaDialogTitle';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: ITheme) => {
    return {
        dialog: {
            padding: '10px',
        },
        dialogActions: {
            padding: '8px 24px',
        },
    };
});

interface Props {
    onSubmitFuncName: string;
    currentGarmentId: number;
    currentCategoryId: number;
}

declare global {
    interface Window {
        openChangeStyleDialog: any;
    }
}

export interface ISelectedSize {
    id: string | number;
    name: string;
    count: string | number;
}

const ChangeStyleDialogContainer: React.FC<Props> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { onSubmitFuncName, currentGarmentId, currentCategoryId } = props;
    const [isOpen, setIsOpen] = useState(false);
    const idDesign = (window as IIndexable)[window.GET_ID_DESIGN_FCE_NAME]();
    const { data: selectedData } = useTypedSelector(
        (state) => state.od.selected
    );
    const { data: teamData } = useTypedSelector((state) => state.od.team);

    useEffect(() => {
        window.openChangeStyleDialog = (goToCheckoutVal: boolean) => {
            setIsOpen(true);
        };

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnClose = () => {
        setIsOpen(false);
    };

    const handleOnSubmit = (garment: Garment) => {
        if (window.hasOwnProperty(onSubmitFuncName)) {
            const designName = (window as IIndexable)[
                window.GET_DESIGN_NAME_FCE_NAME
            ]();
            window.startSaveDesign(
                idDesign,
                garment.getIdProduct(),
                designName.length === 0,
                onSubmitFuncName,
                selectedData,
                teamData,
                true
            );
            handleOnClose();
        } else {
            dispatch(
                actions.addSnackbar(
                    t('Change style dialog is not properly defined'),
                    SnackBarType.WARNING,
                    false
                )
            );
            setIsOpen(false);
        }
    };

    return (
        <Dialog
            onClose={handleOnClose}
            open={isOpen}
            fullWidth={true}
            maxWidth={'md'}
        >
            <KapinuaDialogTitle
                handleOnClose={handleOnClose}
                backText={t('< Back to Designer')}
            >
                <Typography variant="h6">
                    {t('Change garment style')}
                </Typography>
            </KapinuaDialogTitle>
            <DialogContent>
                <Box className={classes.dialog}>
                    <GarmentList
                        handleOnSubmit={handleOnSubmit}
                        currentGarmentId={currentGarmentId}
                        currentCategoryId={currentCategoryId}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeStyleDialogContainer;
